/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type DeleteRestrictedModelsPathParams = NonNullable<operations['deleteRestrictedModels']['parameters']['path']>;

export type DeleteRestrictedModelsRequestBody = OperationRequestBodyContent<operations['deleteRestrictedModels']>;

export interface Input extends DeleteRestrictedModelsPathParams {
  apiVersion?: string;
  body: DeleteRestrictedModelsRequestBody;
}

export async function deleteRestrictedModels(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE('/api/v2/projects/{projectKey}/ai-configs/model-configs/restricted', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
